import Text from '@src/components/Text';
import dayjs from 'dayjs';

import { CreateFamilyEvent } from '../../type';
import * as S from './styled';

const FuneralPreview = ({
  formData,
  title: _title,
}: {
  formData: CreateFamilyEvent;
  title: string;
}) => {
  const {
    date,
    funeralDate,
    targetName,
    address,
    detailAddress,
    contacts,
    remarks,
    paymentAccount,
  } = formData;

  const title = _title.replace('[訃音] ', '');

  return (
    <>
      <Text size={16} weight={500} style={{ marginBottom: 8 }}>
        홈페이지 & 메일
      </Text>
      <S.Container>
        <div
          dangerouslySetInnerHTML={{
            __html: `&nbsp;
<table align="center" bgcolor="#f0f0f0" cellpadding="0" cellspacing="0" width="600" style="font-size: 12px; word-break: break-all; overflow-wrap: break-word; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif; line-height: 22px;">
    <tbody style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
        <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
            <td align="center" valign="top" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 22px; word-break: break-all; overflow-wrap: break-word; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important;">
            <table align="center" bgcolor="#f0f0f0" cellpadding="0" cellspacing="0" width="600" style="font-size: inherit; word-break: break-all; overflow-wrap: break-word; line-height: 22px;">
                <tbody style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                    <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                        <td width="360" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 22px; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important; word-break: break-all; overflow-wrap: break-word;"><span style="font-size: 24px; word-break: break-all; overflow-wrap: break-word;">&nbsp;<strong style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">訃 音</strong></span></td>
                        <td width="20" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 22px; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important; word-break: break-all; overflow-wrap: break-word;">&nbsp;</td>
                        <td idth="260" style="margin: 0px; padding: 0px; font-size: inherit; line-height: 16px; color: rgb(17, 17, 17); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important; word-break: break-all; overflow-wrap: break-word; text-align: center;"><img alt="" src="https://userimg-mkt.tason.com/20210616/ekcplaa_3bd8c90bd50fd996e4ca0ee9bf00f3fa.png" style="border: 0px solid currentcolor; font-size: inherit; word-break: break-all; overflow-wrap: break-word; width: 200px; height: 52px;" /></td>
                    </tr>
                </tbody>
            </table>
            </td>
        </tr>
        <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
            <td style="margin: 0px; padding: 0px; font-size: inherit; line-height: 22px; word-break: break-all; overflow-wrap: break-word; text-align: center; vertical-align: top; background-color: rgb(255, 255, 255); font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important;">
            <table align="center" cellpadding="0" cellspacing="0" width="540" style="font-size: inherit; word-break: break-all; overflow-wrap: break-word; line-height: 22px;">
                <tbody style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                    <tr style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;">
                        <td style="margin: 0px; padding: 0px; font-size: inherit; line-height: 22px; color: rgb(17, 17, 17); word-break: break-all; overflow-wrap: break-word; text-align: center; vertical-align: top; font-family: &quot;맑은 고딕&quot;, &quot;Malgun Gothic&quot;, 돋움, dotum, sans-serif !important;">
                        <p style="margin: 0px 0px 12px; padding: 0px; font-size: inherit; word-break: break-all; overflow-wrap: break-word; line-height: 22px;">&nbsp;</p>
                        <h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;">&nbsp;</h2>
                        <h2 style="margin: 0px 0px 10px; padding: 0px; font-size: inherit; word-break: break-all; overflow-wrap: break-word; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;"><span style="font-size: 22px; word-break: break-all; overflow-wrap: break-word;">${title}</span></h2>
                        &nbsp;
                        <h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;"><span style="font-size: 12px; word-break: break-all; overflow-wrap: break-word; color: rgb(85, 85, 85);">&nbsp;</span></h2>
                        <h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; text-align: left; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;">&nbsp; &nbsp; ◎ 빈 소<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; ${detailAddress}<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; ${address}&nbsp;<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        <br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; ◎ 고 인 명<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; 故 ${targetName
                          .split('')
                          .join(
                            ' ',
                          )}&nbsp; 님<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        <br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; ◎ 별 세<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; ${dayjs(date)
                          .locale('ko')
                          .format(
                            'YYYY년 MMMM D일 dddd',
                          )}<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp;</h2>
                        ${
                          !funeralDate
                            ? ''
                            : `<h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; text-align: left; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;">&nbsp; &nbsp; ◎ 발 인<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; ${dayjs(funeralDate)
                          .locale('ko')
                          .format('YYYY년 MMMM D일 dddd, HH:mm')}</h2>
                        &nbsp;`
                        }
                        ${
                          contacts.length === 0
                            ? ''
                            : `<h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; text-align: left; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;">&nbsp; &nbsp; ◎ 연 락 처<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        ${contacts.map(
                          ({ name, phone }) =>
                            `&nbsp; &nbsp; ${phone} (${name})<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />`,
                        )}`
                        }
                        <br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; <h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular; color: rgb(37, 37, 37); line-height: 24px; text-align: left;">&nbsp; &nbsp; ◎ ${remarks} <br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" /> </h2>
                        ${
                          paymentAccount
                            ? `&nbsp;
                        <h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular; color: rgb(37, 37, 37); line-height: 24px; text-align: left;">&nbsp; &nbsp; ◎ 마음 전하실 곳<br style="font-size: inherit; word-break: break-all; overflow-wrap: break-word;" />
                        &nbsp; &nbsp; ${paymentAccount}</h2>`
                            : ''
                        }
                        &nbsp;
                        <h2 style="margin: 0px 0px 10px; padding: 0px; font-size: 14px; word-break: break-all; overflow-wrap: break-word; color: rgb(37, 37, 37); line-height: 24px; font-family: 나눔고딕, NanumGothic, 맑은고딕, &quot;Malgun Gothic&quot;, dotum, 돋움, Dotum, Helvetica, AppleSDGothicNeo-Regular;"><span style="font-size: 22px; word-break: break-all; overflow-wrap: break-word;">삼가고인의 명복을 빕니다.</span></h2>
                        </td>
                    </tr>
                </tbody>
            </table>
            </td>
        </tr>
    </tbody>
</table>`,
          }}
        />
      </S.Container>

      <Text size={16} weight={500} style={{ marginTop: 12, marginBottom: 8 }}>
        메시지
      </Text>
      <S.Container style={{ width: '384px' }}>
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {`
[訃 音]

${title}
    
◎ 빈    소
  ${detailAddress}
  ${address}
    
◎ 고 인 명
  故 ${targetName} 님
    
 ◎ 별    세
  ${dayjs(date).locale('ko').format('YYYY년 MMMM D일 dddd')}
${
  funeralDate
    ? `\n◎ 발    인
  ${dayjs(funeralDate).locale('ko').format('YYYY년 MMMM D일 dddd, HH:mm')}`
    : ''
}
${
  contacts && contacts.length
    ? `\n◎ 연 락 처
${contacts
  .map(info => {
    return `  ${info.phone} (${info.name})`;
  })
  .join('\n')}`
    : ''
}

◎ ${remarks}
${
  paymentAccount
    ? `\n◎ 마음 전하실 곳
  ${paymentAccount}`
    : ''
}
    
삼가고인의 명복을 빕니다.`}
        </div>
      </S.Container>
    </>
  );
};

export default FuneralPreview;
